import { type TransformerConfig } from '../common/types';
import { createDecodeFromDbFn, createEncodeToDbFn } from '../common/utils';
import { createSha256Transformer, createTimestampTransformer } from '../common/sql';
import { EnrichmentRunSchema, DBEnrichmentRunSchema } from './schemas';

export const EnrichmentRunCodecConfig: TransformerConfig<
  typeof EnrichmentRunSchema,
  typeof DBEnrichmentRunSchema
> = {
  name: 'EnrichmentRun',
  clientSchema: EnrichmentRunSchema,
  dbSchema: DBEnrichmentRunSchema,
  transformers: [
    ...(['configHash', 'scopeHash'] as const).map(field =>
      createSha256Transformer<typeof EnrichmentRunSchema, typeof DBEnrichmentRunSchema>(field)
    ),
    ...(['startedAt', 'finishedAt', 'updatedAt'] as const).map(field =>
      createTimestampTransformer<typeof EnrichmentRunSchema, typeof DBEnrichmentRunSchema>(field, {
        nullable: true,
      })
    ),
    createTimestampTransformer<typeof EnrichmentRunSchema, typeof DBEnrichmentRunSchema>(
      'createdAt'
    ),
  ],
};

export const encodeEnrichmentRunToDb = createEncodeToDbFn(EnrichmentRunCodecConfig);
export const decodeEnrichmentRunFromDb = createDecodeFromDbFn(EnrichmentRunCodecConfig);
